import { Injectable } from '@angular/core';
import { GgAiTroubleshootAdapter } from './gg-ai-troubleshoot.adapter';
import { Observable } from 'rxjs';
import { GGFaqsAI, GGSapIdWSDTO } from '../../components/gg-ai-troubleshoot/gg-ai-troubleshoot.component';

@Injectable()
export class GgAiTroubleshootConnector {
  constructor(private ggAiTroubleshootAdapter: GgAiTroubleshootAdapter) {}

  getSapIdFromAuidOrSn(auidOrSn: string): Observable<GGSapIdWSDTO> {
    return this.ggAiTroubleshootAdapter.getSapIdFromAuidOrSn(auidOrSn);
  }

  getFaqsAI(auidOrSn: string, issueDescription: string): Observable<GGFaqsAI> {
    return this.ggAiTroubleshootAdapter.getFaqsAI(auidOrSn, issueDescription);
  }
}
